// eslint-disable-next-line no-restricted-syntax
export enum LeagueAlias {
  PGA = 'pga',
  NFL = 'nfl',
  NBA = 'nba',
  NCAAF = 'ncaaf',
  NCAAB = 'ncaab',
  MLB = 'mlb',
  WC = 'wc',
}
